import React from 'react'

function PhotoGalleryEvent() {
  return (
    <div>PhotoGalleryEvent</div>
  )
}

export default PhotoGalleryEvent